import { render, staticRenderFns } from "./switch-organization.modal.vue?vue&type=template&id=5e1c65c1&"
import script from "./switch-organization.modal.vue?vue&type=script&lang=ts&"
export * from "./switch-organization.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports